import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=78e58065&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e58065",
  null
  
)

export default component.exports